import { useSelector } from "react-redux";
import { RootState } from "../../store";

import classes from "./RefreshBanner.module.css";
import { t } from "../../i18n";

// Slides down while a background sync is in flight. Deliberately not a modal -
// the user didn't ask for this refresh, so it must not block anything.
const RefreshBanner = () => {
  const { isRefreshing } = useSelector((state: RootState) => state.ui);

  return (
    <div className={`${classes.banner} ${isRefreshing ? classes.show : ""}`}>
      {t.refreshing}
    </div>
  );
};

export default RefreshBanner;
